import styled from 'styled-components';
import Link from '../Link';
import { Typography } from '../Typography';

export const Background = styled.div`
  background: ${({ theme }) => theme.colors.functional.gray2};
  height: 80px;
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;
  @media (max-width: ${({ theme }) => theme.navBreakPoints.lg}) {
    display: none;
  }
`;

export const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 240px);
  max-width: 1920px;
  z-index: 2;
  justify-content: space-between;
  display: flex;
  @media (max-width: ${({ theme }) => theme.navBreakPoints.lg}) {
    display: none;
  }
`;

//   @apply h-[80px] w-[214px] flex-center;
export const LogoWrapper = styled.div`
  display: flex;
  align-center: center;
  align-items: center;
  justify-content: center;
  a {
    height: 3.6rem;
    display: flex;
    svg,
    img {
      width: 100%;
    }
  }
`;

// Total height is 80px
// Nav buttons are 48px
// 80 - 48 = 32px / 2 = 16px
export const Container = styled.div`
  display: flex;
  padding: 16px 0;
`;

export const StyledLink = styled(Link)<{ $isActive?: boolean; isRow?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: none;
  margin-right: 48px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin-right: 40px;
  }

  :hover {
    color: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
  }

  ${({
    $isActive,
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) =>
    $isActive &&
    `
    color: ${main};
  `}

  ${({ isRow }) =>
    isRow &&
    `
    flex-direction: row;
  `};
`;

export const StyledEm = styled.em`
  display: block;
  height: 2px;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
`;

export const StyledSpan = styled(Typography)`
  display: block;
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  font-size: 14px;
  color: inherit;
  font-weight: 700;
  line-height: 18px;
`;
